import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es un curso?',
  a: 'No. Es un sistema paso a paso en PDF con actividades, planillas y protocolos. Lo hacés a tu ritmo.'
}, {
  q: '¿Necesito saber de finanzas?',
  a: 'Para nada. Está pensado para personas comunes que quieren ordenarse sin tecnicismos.'
}, {
  q: '¿Funciona si gano poco?',
  a: 'Sí. El sistema se adapta a cualquier ingreso. No importa cuánto ganás, importa cómo lo organizás.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Inmediatamente después del pago recibís el acceso por email. Son archivos PDF descargables.'
}, {
  q: '¿Puedo pagar con Mercado Pago?',
  a: 'Sí. Aceptamos Mercado Pago, tarjeta de crédito y débito.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía. Si no te sirve, te devolvemos el 100% sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-white/60 backdrop-blur-sm" data-id="element-48">
      <div className="container mx-auto px-4" data-id="element-49">
        <div className="text-center mb-10" data-id="element-50">
          <h2 className="text-2xl md:text-3xl font-black text-black uppercase tracking-tight" data-id="element-51">
            ❓ Lo que más nos preguntan
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 bg-[#73A2EE]" data-id="element-52">
          {faqs.map((faq, i) => <div key={i} className="bg-blue-50 rounded-xl border border-blue-200 overflow-hidden" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex items-center justify-between font-bold text-black text-sm hover:bg-slate-100 transition-colors" data-id="element-54">
                {faq.q}
                <ChevronDown size={18} className={`transform transition-transform duration-300 text-blue-600 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>
              <AnimatePresence data-id="element-56">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-5 pb-4 text-slate-600 text-sm border-t border-slate-200 pt-3" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}